// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"d21548e2","223":"495de1e6","239":"4a41bfb1","450":"cc1c5197","732":"e959aae1","977":"2899dd08"}[chunkId] + ".chunk.js";
};